import { Constants } from '@constants';
import {
    IconQuestionMarkFilled,
    IconPhoneFilled,
    IconEmailFilled
} from '@iwoca/icons';
import { Accordion, IwocaLogo } from '@iwoca/orion';
import { Text } from '@iwoca/orion-ui';
import { FormattedMessage } from 'react-intl';

import { TrustPilot } from '../../../TrustPilot/TrustPilot';

const ContactDetails = () => (
    <ul className="flex flex-col gap-xs">
        <li className="flex flex-row gap-x-xs">
            <IconQuestionMarkFilled className="my-auto text-primary-10 min-m:text-structure-100" />
            <FormattedMessage
                id="_.credit_card.sidebar.help.FAQ"
                defaultMessage="Find answers in our <a>FAQ</a>"
                values={{
                    a: (chunks) => (
                        <a href={'/faq'}>
                            <strong>{chunks}</strong>
                        </a>
                    )
                }}
            />
        </li>

        <li className="flex flex-col">
            <p className="flex flex-row gap-x-xs">
                <IconPhoneFilled className="my-auto text-primary-10 min-m:text-structure-100" />
                <FormattedMessage
                    id="_.credit_card.sidebar.help.call"
                    defaultMessage="Call us on <a>{phone}</a>"
                    values={{
                        phone: Constants.CREDIT_CARD_PHONE_NUMBER.display,
                        a: (chunks) => (
                            <a
                                href={`tel:${Constants.CREDIT_CARD_PHONE_NUMBER.tel}`}
                            >
                                <strong>{chunks}</strong>
                            </a>
                        )
                    }}
                />
            </p>
            <p className="mt-[-10px]">
                <FormattedMessage
                    id="_.credit_card.sidebar.help.open_times"
                    defaultMessage="Monday to Friday 9am - 6pm (excluding bank holidays)"
                />
            </p>
        </li>

        <li className="flex flex-row gap-x-xs">
            <IconEmailFilled className="col-span-1 my-auto text-primary-10 min-m:text-structure-100" />
            <FormattedMessage
                id="_.credit_card.sidebar.help.email"
                defaultMessage="Email us at <a>{email}</a> "
                values={{
                    email: Constants.EMAIL,
                    a: (chunks) => (
                        <a href={`mailto:${Constants.EMAIL}`}>
                            <strong> {chunks}</strong>
                        </a>
                    )
                }}
            />
        </li>
    </ul>
);

export const ContactFooter = () => {
    return (
        <>
            {/* Mobile layout */}
            <div className="mx-4xl my-l block min-m:hidden">
                <div className="mx-auto w-3xl border-t pt-2xl"></div>
                <Text className="mb-xl text-m font-bold text-primary-10">
                    <FormattedMessage
                        id="_.credit_card.sidebar.highlight.need_help"
                        defaultMessage="Still need help?"
                    />
                </Text>
                <ContactDetails />
                <div className="mx-auto my-l flex flex-col justify-center text-center">
                    <IwocaLogo
                        className="m-auto h-[90px] w-[90px]"
                        color="red"
                    />
                    <TrustPilot />
                </div>
            </div>

            <div className="hidden min-m:block">
                <Accordion
                    data-testid="credit-card-accordion-container"
                    frame={false}
                    small
                    className="bg-transparent text-structure-100"
                    title={
                        <Text className="text-s font-med text-structure-100">
                            <FormattedMessage
                                id="_.credit_card.sidebar.highlight.need_help"
                                defaultMessage="Still need help?"
                            />
                        </Text>
                    }
                >
                    <ContactDetails />
                </Accordion>

                <div className="flex flex-col justify-center text-center">
                    <IwocaLogo className="m-auto h-5xl w-5xl" color="white" />
                    <TrustPilot theme="dark" />
                </div>
            </div>
        </>
    );
};
